export default __webpack_public_path__ + "static/green-first-69284c5315e1b75ed082edb2ab29d6f3.svg";